import Vue from "vue";
import humanizeDuration from "humanize-duration";
Vue.filter("humanizer", value => {
  if (value == 0) {
    return "Never Used";
  }

  var value = humanizeDuration(value, {
    units: ["y", "mo", "w", "d"],
    round: true,
    language: "en",
    largest: 1
  });

  if (value == "0 days") {
    return "Today";
  }
  return value;
});
